<template>
    <b-row class="status-coordinates-wrapper pt-1">
        {{ /* last updated */ }}
        <b-col class="pb-2" cols="12" v-if="lastUpdatedObject">
            <span class="last-updated-small">
                {{ $t('dashboard.right-panel-last-update') }}: {{ lastUpdatedObject }}
            </span>
        </b-col>

        {{ /*coordinates*/ }}
        <b-col class="details-dam-coordinates">
            {{ /* The empty val of administrative_region is null */ }}
            <div
                class="d-flex negative-margin"
                v-if="administrativeRegion"
            >
                <SvgIcon name="map-pin-dark" :width="15" :height="16"/>
                <span class="administrative-region small ml-2">{{ administrativeRegion }}</span>
            </div>
            <div v-else>
                <StatusDotText
                    :status-arr="currentDamSelectedStatus"
                    :overflow-info="currentDamOverflowInfo"
                ></StatusDotText>
            </div>

            <div class="d-flex flex-wrap justify-content-center">
                <span class="mx-1">
                    <span class="coordinates-first">{{ currentDamSelectedCoordinates[0] }}</span>
                    <span>&#x26AC; {{ $t('dashboard.north') }},</span>
                </span>
                <span class="mx-1">
                    <span class="coordinates-second"> {{ currentDamSelectedCoordinates[1] }}</span>
                    <span>&#x26AC; {{ $t('dashboard.east') }}</span>
                </span>
            </div>
        </b-col>

        {{ /*status*/ }}
        <b-col
            sm="12"
            class="details-dam-status mt-2"
            v-if="administrativeRegion"
        >
            <StatusDotText
                :status-arr="currentDamSelectedStatus"
                :overflow-info="currentDamOverflowInfo"
            ></StatusDotText>
        </b-col>
    </b-row> <!-- /row status-coordinates-wrapper -->
</template>

<script>
    // utils, vuex
    import {mapGetters} from "vuex";
    // components
    import StatusDotText from "../shared/StatusDotText";
    import SvgIcon from '../shared/SvgIcon';
    import {formatDate, parsedDate} from "../../utils/common";

    /**
     * Holds the name of the station and the status,
     * plus the coordinates.
     */

    export default {
        name: "RightPanelContainerName",
        components: {
            StatusDotText,
            SvgIcon
        },
        computed: {
            ...mapGetters([
                'currentDamSelectedStatus',
                'currentDamSelectedCoordinates',
                'currentDamSelectedLastUpdated',
                'currentDamOverflowInfo'
            ]),
            administrativeRegion() {
                if (this.currentDamSelected && this.currentDamSelected.length > 0) {
                    return this.currentDamSelected[7]["administrative_region"];
                }
                return null;
            },
            lastUpdatedObject() {
                if (this.currentDamSelectedLastUpdated) {
                    const lastUpdatedDate = parsedDate(this.currentDamSelectedLastUpdated);
                    return formatDate(lastUpdatedDate);
                }
                return '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .last-updated-small {
        text-align: left;
        font-weight: $font-weight-light;
        font-family: $font-family-base;
        font-size: $font-size-sm;
        line-height: $font-size-slg;
        letter-spacing: 0;
        color: $semiDarkGrey;
        opacity: 1;
    }

    .status-coordinates-wrapper {
        padding-bottom: 0.9rem;

        .details-dam-coordinates {
            display: flex;
            justify-content: space-between;
            font: 300 12px/16px Nunito, sans-serif;
            letter-spacing: 0;
            color: #000000;
            opacity: 1;
        }

        .administrative-region {
            font-weight: inherit;
        }
    }

    .details-dam-status,
    .details-dam-coordinates {
        line-height: 16px;
    }

    .negative-margin {
        margin-left: -4px;
    }
</style>